import { render, staticRenderFns } from "./MessageHistoryLog.vue?vue&type=template&id=52d033d8&scoped=true&"
import script from "./MessageHistoryLog.vue?vue&type=script&lang=ts&"
export * from "./MessageHistoryLog.vue?vue&type=script&lang=ts&"
import style0 from "./MessageHistoryLog.vue?vue&type=style&index=0&id=52d033d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d033d8",
  null
  
)

export default component.exports